export const chartSections: string[] = [
    "maps",
    "mixed",
    "bars",
    "heatmap",
]